import React from 'react';
import { 
  HelpCircle, 
  CreditCard, 
  Clock, 
  FileText, 
  Shield, 
  Zap, 
  Book, 
  PiggyBank
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: CreditCard,
      title: 'Учёт доходов',
      description: 'Фиксируйте все поступления сразу в приложении «Мой налог», чтобы не пропустить сроки формирования чеков.'
    },
    {
      icon: Clock,
      title: 'Сроки уплаты',
      description: 'Налог необходимо оплатить до 25 числа следующего месяца. Настройте уведомления, чтобы не пропустить платеж.'
    },
    {
      icon: FileText,
      title: 'Сохраняйте чеки',
      description: 'Храните копии всех сформированных чеков и квитанции об оплате налога для подтверждения легальности дохода.'
    },
    {
      icon: Shield,
      title: 'Отношения с клиентами',
      description: 'Заключайте договоры с заказчиками. Это поможет защитить ваши права и четко обозначить условия сотрудничества.'
    },
    {
      icon: Zap,
      title: 'Следите за лимитом',
      description: 'Контролируйте годовой доход – при превышении 2,4 млн рублей нужно перейти на другой налоговый режим.'
    },
    {
      icon: Book,
      title: 'Отделяйте финансы',
      description: 'Используйте отдельный счет для бизнес-операций, чтобы упростить учет доходов и избежать претензий налоговой.'
    },
    {
      icon: PiggyBank,
      title: 'Пенсионные накопления',
      description: 'Рассмотрите возможность добровольных взносов на пенсионное страхование для формирования будущей пенсии.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы для самозанятых
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Бесплатная консультация ФНС
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Если у вас возникли вопросы по налогу на профессиональный доход, вы можете позвонить в контактный центр ФНС России.
            </p>
            <a 
              href="tel:88002224222" 
              className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors flex items-center justify-center"
            >
              8-800-222-22-22
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;